import { Box, Divider, Menu, MenuItem, Stack, useTheme } from '@mui/material'
import { useState } from 'react'
import { Button } from '@/components/atoms/button'
import { MvTypography } from '@/components/atoms/mv-typography'
import { isLocalDbEnabled } from '../config'
import { currentUserId } from '../engine/context'
import { resetLocalDb, switchPersona } from '../index'
import { LOCAL_DB_PERSONAS } from '../seed'
import { readTable } from '../store/localDb.store'

/**
 * Panel kecil khusus local mode: ganti persona (satu role per user) dan reset data seed.
 * Bukan bagian modul produksi — hanya dirender saat `NEXT_PUBLIC_LOCAL_DB=true`.
 */
export const LocalDbDevtools = () => {
  const theme = useTheme()
  const [anchor, setAnchor] = useState<HTMLElement | null>(null)

  if (!isLocalDbEnabled()) return null

  const roles = new Map(readTable('mt_roles').map(role => [role.id, String(role.name)]))
  const active = LOCAL_DB_PERSONAS.find(persona => persona.id === currentUserId())

  const reloadWith = (action: () => void) => {
    action()
    setAnchor(null)
    window.location.reload()
  }

  return (
    /* zIndex di bawah Drawer/Modal MUI (1300) agar lembar bawah layar scan mobile tidak tertutup. */
    <Box sx={{ position: 'fixed', left: 16, bottom: 16, zIndex: 1200 }}>
      <Button
        content='iconText'
        icon='tabler:database-cog'
        text={active ? `${active.first_name} · ${roles.get(active.roleId) ?? ''}` : 'Local DB'}
        variant='contained'
        color='secondary'
        size='small'
        onClick={event => setAnchor(event.currentTarget)}
      />
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        <Stack px={2} py={1}>
          <MvTypography size='LABEL_SM_BOLDEST' color={theme.colorToken.text.neutral.subtle}>
            LOCAL MODE · GANTI PERSONA
          </MvTypography>
        </Stack>
        {LOCAL_DB_PERSONAS.map(persona => (
          <MenuItem
            key={persona.id}
            selected={persona.id === active?.id}
            onClick={() => reloadWith(() => switchPersona(persona.id))}
          >
            <MvTypography size='BODY_SM_NORMAL'>
              {persona.first_name} {persona.last_name} —{' '}
              <MvTypography component='span' size='BODY_SM_NORMAL' color={theme.colorToken.text.neutral.subtle}>
                {roles.get(persona.roleId)}
              </MvTypography>
            </MvTypography>
          </MenuItem>
        ))}
        <Divider />
        <MenuItem onClick={() => reloadWith(resetLocalDb)}>
          <MvTypography size='BODY_SM_NORMAL' color={theme.colorToken.text.danger.normal}>
            Reset data demo ke seed awal
          </MvTypography>
        </MenuItem>
      </Menu>
    </Box>
  )
}
